import { useMemo } from "react";
import { FilterProps } from "react-table";

import { SingleSelectFilter } from "@/components/elements/DataTable";

import { RowData } from "../columns";

const optionsMap = {
  active: {
    value: true,
    label: "Active",
    count: 0,
  },
  inactive: {
    value: false,
    label: "Inactive",
    count: 0,
  },
};

export function StatusFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}: FilterProps<RowData>) {
  const options = useMemo(() => {
    optionsMap.active.count = preFilteredRows.filter(
      (x) => x.original.active,
    ).length;
    optionsMap.inactive.count =
      preFilteredRows.length - optionsMap.active.count;
    return Object.values(optionsMap);
  }, [preFilteredRows]);

  const currentValue =
    options.find((option) => option.value === filterValue) ?? null;

  return (
    <SingleSelectFilter
      value={currentValue}
      options={options}
      onChange={(value) => {
        setFilter(value.value);
      }}
      onClear={() => setFilter(undefined)}
      placeholder="All sync states"
      name="State"
    />
  );
}
